import type { UserRow } from '../userViewModel';

import UserAvatar from './UserAvatar';

export default function EditRoleHeader({ user }: { user: UserRow }) {
  return (
    <div className="px-[22px] py-[18px] border-b border-stone-200 dark:border-stone-800 flex items-center gap-3">
      <UserAvatar name={user.name} size={36} />
      <div className="flex-1">
        <h2
          id="edit-role-title"
          className="m-0 text-lg font-bold text-bark-900 dark:text-[#e8ece9] leading-none"
        >
          Edit role &amp; regions
        </h2>
        <div className="text-[12px] text-stone-600 dark:text-stone-400 mt-1">
          {user.name} · {user.email ?? 'no email on file'}
        </div>
      </div>
    </div>
  );
}
